module.exports = __webpack_public_path__ + "static/media/doctor.c6beb3ae.svg";